import { useAppDispatch } from "core/utils";
import { useState } from "react";
import { useParams } from "react-router";

import { CardProfileEditForm } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/components/forms/CardProfileEditForm";
import { ActionBar } from "../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../../../components/FeatureButtons/SubmitButton";
import { ResourceName, ResourceVariant } from "../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../core/router/types/routerTypes";
import { setDefaultActiveKey } from "../../../../../../core/setup/redux/state/tabs/tabState";

export const CardProfileApacEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);

    const { appProfileId } = useParams();
    const backUrl = `${BASE_PATH}/${ResourceName.APPLICATION_PROFILE_LISTS}/${ResourceVariant.APAC}/${FORM_ACTION.EDIT}/${appProfileId}`;

    const dispatch = useAppDispatch();
    const setTabsDefaultBeforeBack = () => dispatch(setDefaultActiveKey("applications-profiles_cardProfiles"));

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.cardProfilesApacEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <BackButton isDisabled={false} url={backUrl} onBeforeNavigate={setTabsDefaultBeforeBack} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CardProfileEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
